/**
 * URL parameters parsed once at module-load time (before any React render).
 *
 * In Zitadel / hosted-game mode the host app appends these to the iframe URL:
 *   ?token=<jwt>&stageId=<id>&gameSessionId=<id>&key=<key>
 */
const _p = new URLSearchParams(window.location.search);

export const urlParams = {
  /** Zitadel bearer token — present in Zitadel mode. */
  token: _p.get('token') ?? '',
  /** Backend stage identifier — present in Zitadel mode. */
  stageId: _p.get('stageId') ?? '',
  /** Game session identifier — present in Zitadel mode. */
  gameSessionId: _p.get('gameSessionId') ?? '',
  /** Game key — present in Zitadel mode. */
  key: _p.get('key') ?? '',
  /** Board identifier — present in preview mode only. */
  boardId: _p.get('boardId') ?? '',
  /** Whether to enable the game timer. */
  timer: _p.get('timer') === 'true',
  /** Optional custom time limit for the game session. */
  timeLimit: _p.has('timeLimit') ? Number(_p.get('timeLimit')) : null,
  /** Optional custom board count limit for the game session. */
  boardCount: _p.get('boardCount') ?? '',
  /** Optional difficulty. */
  difficulty: _p.get('difficulty') ?? '',
} as const;

/**
 * True when the app is launched in Zitadel / hosted-game mode.
 * Presence of `?token=` + `?stageId=` indicates Zitadel.
 */
export const isZitadelMode = !!(urlParams.token && urlParams.stageId && !urlParams.boardId);
